import { Component } from 'react';
import { Input, Label, Box } from 'roo-ui/components';
import LoadingButton from 'components/LoadingButton';
import LoginError from '../LoginError';

class GatekeeperLoginForm extends Component {
  state = {
    bookingReference: '',
    email: '',
    lastName: '',
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { bookingReference, email, lastName } = this.state;

    this.props.createAuthentication({
      bookingId: this.props.bookingId,
      bookingReference: bookingReference.trim(),
      email: email.trim(),
      lastName: lastName.trim(),
    });
  };

  handleFieldChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleBookingReferenceFieldChange = (event) => {
    this.setState({ [event.target.name]: (event.target.value || '').toUpperCase() });
  };

  isFormDisabled = () => !(this.state.bookingReference && this.state.email && this.state.lastName);

  render() {
    const { isAuthenticating, authError } = this.props;

    return (
      <Box px="15px">
        <Box mb={8}>Enter your details to view or cancel your Qantas Hotels booking</Box>
        {authError && <LoginError error={authError} />}
        <form onSubmit={this.handleSubmit} data-testid="gatekeeper-login-form" data-hj-suppress>
          <Label htmlFor="email" mt={6} mb={2}>
            Email address
          </Label>
          <Input
            value={this.state.email}
            type="email"
            name="email"
            placeholder="Enter your email address"
            onChange={this.handleFieldChange}
            disabled={isAuthenticating}
            data-testid="email-input"
          />
          <Label htmlFor="lastName" mt={6} mb={2}>
            Last name
          </Label>
          <Input
            value={this.state.lastName}
            name="lastName"
            placeholder="Enter your last name"
            onChange={this.handleFieldChange}
            disabled={isAuthenticating}
            data-testid="last-name-input"
          />
          <Label htmlFor="bookingReference" mt={6} mb={2}>
            Booking reference
          </Label>
          <Input
            value={this.state.bookingReference}
            name="bookingReference"
            placeholder="Enter your booking reference"
            onChange={this.handleBookingReferenceFieldChange}
            disabled={isAuthenticating}
            data-testid="booking-ref-input"
          />
          <LoadingButton
            data-testid="gatekeeper-form-submit"
            variant="primary"
            block
            type="submit"
            disabled={this.isFormDisabled()}
            loading={isAuthenticating}
            mt={8}
          >
            Manage Booking
          </LoadingButton>
        </form>
      </Box>
    );
  }
}
GatekeeperLoginForm.displayName = 'GatekeeperLoginForm';

export default GatekeeperLoginForm;
